<div class="modal-header d-flex justify-content-between align-items-center px-4 py-3 border-bottom">

  <div>
    <h2 class="text-muted small">
      Update Event Date
    </h2>

    <div class="text-muted small">
      <i class="bi bi-calendar-event me-1"></i>
      {{ EventId }}
    </div>
  </div>



  <button
    type="button"
    class="btn btn-light rounded-circle shadow-sm close-btn"
    mat-dialog-close
  >
    ×
  </button>

</div>

<form [formGroup]="form">

  <mat-dialog-content>

    <!-- Date -->
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Select Date</mat-label>



      <input matInput 
             [matDatepicker]="picker" 
             formControlName="eventDate"
             [min]="minDate"
             (dateChange)="onDateChange($event)">

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>

      <mat-error *ngIf="form.get('eventDate')?.hasError('required')">
        Date is required
      </mat-error>
    </mat-form-field>


    <!-- ✅ Time Field -->
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Select Time</mat-label>

      <input matInput 
             type="time" 
             formControlName="eventTime">

      <mat-error *ngIf="form.get('eventTime')?.hasError('required')">
        Time is required
      </mat-error>
    </mat-form-field>


      <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Remark</mat-label>

      <input matInput 
             type="text" 
             formControlName="Remark">

      <mat-error *ngIf="form.get('Remark')?.hasError('required')">
        Remark is required
      </mat-error>
    </mat-form-field>

    <div class="col-md-12">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Upload File</mat-label>

      <!-- Hidden file input -->
      <input type="file" 
             #fileInput 
             hidden 
                  accept="application/pdf"
             (change)="onFileSelect($event)">

      <!-- Visible input -->
      <input matInput 
             [value]="selectedFileName" 
             placeholder="Choose file..." 
             readonly>

      <!-- Upload Button -->
      <button mat-icon-button matSuffix (click)="fileInput.click()">
        <!--<mat-icon>attach_file</mat-icon>-->
        <i class="bi bi-paperclip me-2"></i>
      </button>

      <!-- Clear Button -->
      <button mat-icon-button matSuffix *ngIf="selectedFileName" (click)="clearFile()">
        <!--<mat-icon>close</mat-icon>-->
        <i class="bi bi-x me-2"></i>
      </button>

    </mat-form-field>
  </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" (click)="close()">
      Cancel
    </button>




    <button mat-raised-button 
            color="primary" 
            (click)="save()" 
            [disabled]="form.invalid">
      Save
    </button>
  </mat-dialog-actions>

</form>
